import { Providers } from '@/app/providers/Providers';
import { router } from '@/app/router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import '@/app/globals.css';

// Vite SPA entry — replaces the Next.js root layout. Global providers
// (Tolgee i18n, React Query, Auth, Toaster) wrap the React Router tree.
createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
